import React from 'react';
import PropTypes from 'prop-types';
import { Text, Icon } from '@cubeyou-team/hx-react-components';
import styled from 'styled-components';

const StyledCurrentNavItem = styled.div`
  display: flex;
  margin-right: 4px;
  align-items: center;
`;

const StyledButtonBack = styled.button`
  margin-right: 8px;
  display: flex;
  justify-content: center;
  width: 32px;
  height: 100%;
  align-items: center;
  background: none;
  border: 0;
  cursor: pointer;
  &:hover,
  &:active {
    background-color: ${props => props.theme.colors.secondary_alpha_3};
    outline: none;
  }
`;

const getCurrent = nav => {
  return (
    <Text tag="span" size="small" weight="regular">
      {nav.label}
    </Text>
  );
};

const FoldersBreadcrumbsItem = ({
  nav,
  islastButOne,
  last,
  index,
  onNavigationClick,
}) => {
  if (last) {
    return <StyledCurrentNavItem>{getCurrent(nav)}</StyledCurrentNavItem>;
  }

  if (islastButOne) {
    return (
      <StyledButtonBack
        index={index}
        data-test-id="hx-navigation-back"
        onClick={() => {
          onNavigationClick(nav, true);
        }}
      >
        <Icon icon="chevron_left" size="xsmall" />
      </StyledButtonBack>
    );
  }

  return null;
};

FoldersBreadcrumbsItem.propTypes = {
  nav: PropTypes.object,
  last: PropTypes.bool,
  index: PropTypes.number,
  onNavigationClick: PropTypes.func,
};

export default FoldersBreadcrumbsItem;
